import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { 
  FaHeadphones, 
  FaBook, 
  FaMicrophone,
  FaPen,
  FaClock
} from 'react-icons/fa';
import './oet.css';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';

function OET() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define OET sections with icons and descriptions
  const oetSections = [
    {
      title: 'OET Listening',
      icon: <FaHeadphones className="ext_oet_section-icon" />,
      description: 'Master OET listening skills and strategies'
    },
    {
      title: 'OET Reading',
      icon: <FaBook className="ext_oet_section-icon" />,
      description: 'Improve your medical reading comprehension'
    },
    {
      title: 'OET Speaking',
      icon: <FaMicrophone className="ext_oet_section-icon" />,
      description: 'Practice medical role-play scenarios'
    },
    {
      title: 'OET Writing',
      icon: <FaPen className="ext_oet_section-icon" />,
      description: 'Learn to write effective referral letters'
    },
    {
      title: 'Exam Day',
      icon: <FaClock className="ext_oet_section-icon" />,
      description: 'Prepare for your OET exam day'
    }
  ];

  return (
    <div className={`ext_oet_page-container ${isDarkMode ? 'ext_oet_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_oet_main-content">
        <div className="ext_oet_header">
          <h1>OET Resources</h1>
          <p>Comprehensive preparation materials for the Occupational English Test</p>
        </div>

        <div className="ext_oet_sections-grid">
          {oetSections.map((section, index) => (
            <div 
              key={index}
              className="ext_oet_section-card"
            >
              <div className="ext_oet_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="ext_oet_coming-soon">Coming Soon</div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default OET; 